/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



//////////////////
// WEBPACK FOOTER
// ./~/redux/~/symbol-observable/index.js
// module id = 2909
// module chunks = 0